export const API_URL = "https://todolistsqlaran.azurewebsites.net";
// export const API_URL = "http://localhost:59843"; //old backend
// export const API_URL = "https://localhost:44388"; //new backend entity framework